/** Reinicia los datos del navegador pertenecientes a este sitio. */
export async function clearSiteData(): Promise<void> {
  try { localStorage.clear(); } catch { /* Almacenamiento no disponible. */ }
  try { sessionStorage.clear(); } catch { /* Almacenamiento no disponible. */ }

  for (const cookie of document.cookie.split(";")) {
    const name = cookie.split("=")[0].trim();
    if (!name) continue;
    const expired = `${name}=; Max-Age=0; Path=/; SameSite=Lax`;
    document.cookie = expired;
    document.cookie = `${expired}; Domain=${location.hostname}`;
  }

  // La app actualmente usa localStorage; se limpian también posibles cachés.
  if ("caches" in window) {
    try { await Promise.all((await caches.keys()).map((name) => caches.delete(name))); }
    catch { /* El navegador puede restringir Cache Storage. */ }
  }
  if ("indexedDB" in window && typeof indexedDB.databases === "function") {
    try {
      const databases = await indexedDB.databases();
      await Promise.all(databases.filter((database) => database.name).map((database) => new Promise<void>((resolve) => {
        const request = indexedDB.deleteDatabase(database.name!);
        request.onsuccess = () => resolve();
        request.onerror = () => resolve();
        request.onblocked = () => resolve();
      })));
    } catch { /* IndexedDB no disponible. */ }
  }
}
